import React, { Component } from 'react';
import { connect } from 'react-redux';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import FormattedCurrencyValue from '../fields/number/FormattedCurrencyValue';

const log = new Logger('TRANSACTION_REPORT_ECL', LOG_LEVELS.DEBUG);

class ReportECL extends Component {

  render() {
    log.debug('render(): ', this.props);

    if (!this.props.src) {
      return(
        <div><LanguageStringResolver string='transactionBlank_noData'/></div>
      )
    }

    return(
      <table className="mb20">
        <thead>
          <tr>
            <th><LanguageStringResolver string='transactionInvoice_type'/></th>
            <th><LanguageStringResolver string='transactionInvoice_country'/></th>
            <th><LanguageStringResolver string='transactionInvoice_VATNumber'/></th>
            <th><LanguageStringResolver string='transactionInvoice_lineAmount'/></th>
            <th><LanguageStringResolver string='transactionInvoice_ECListingType'/></th>
          </tr>
        </thead>

          {this.props.src.map((item, index) => (
            <tbody key={index}>
              {item.ecListingLines.map((line, subidx) => (
                <tr key={subidx}>
                  <td>{item.ecListingType_str}</td>
                  <td>{line.country}</td>
                  <td>{line.vatNumber}</td>
                  <td><FormattedCurrencyValue value={line.amount}/></td>
                  <td>{line.ecListingLineType_str}</td>
                </tr>
              ))}
            </tbody>
          ))}
      </table>
   );
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {};
}


function mapDispatchersToProps(dispatch) {
  return {}
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(ReportECL);
